import {
  FETCH_MOVEMENT_REASONS_REQUEST,
  FETCH_MOVEMENT_REASONS_SUCCESS,
  FETCH_MOVEMENT_REASONS_FAILURE,
  SAVE_MOVEMENT_REASON_REQUEST,
  SAVE_MOVEMENT_REASON_SUCCESS,
  SAVE_MOVEMENT_REASON_FAILURE,
  DELETE_MOVEMENT_REASON_REQUEST,
  DELETE_MOVEMENT_REASON_SUCCESS,
  DELETE_MOVEMENT_REASON_FAILURE,
} from './types';

const INITIAL_STATE = {
  movementReasonList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MOVEMENT_REASONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MOVEMENT_REASONS_SUCCESS:
      return {
        ...state,
        loading: false,
        movementReasonList: action.payload,
      };

    case FETCH_MOVEMENT_REASONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        movementReasonList: [],
      };
    case SAVE_MOVEMENT_REASON_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_MOVEMENT_REASON_SUCCESS:
      return {
        ...state,
      };

    case SAVE_MOVEMENT_REASON_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_MOVEMENT_REASON_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_MOVEMENT_REASON_SUCCESS:
      return {
        ...state,
      };

    case DELETE_MOVEMENT_REASON_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
